<template>
  <div class="manner_box">
    <h3 class="activeR">我的态度</h3>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="all">
        <template #label>
          <el-dropdown trigger="hover">
            <span class="el-dropdown-link"> 全部 </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>足彩14场</el-dropdown-item>
                <el-dropdown-item>足彩9场</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-tab-pane>
      <el-tab-pane label="中奖" name="correct"></el-tab-pane>
      <el-tab-pane label="结束" name="finish"></el-tab-pane>
    </el-tabs>
    <el-card>
      <div class="content">
        <div class="content_l content_l_h">
          <span>足球14场</span>
          <span>14中5</span>
        </div>
        <div class="content_r">
          <p>第21023期 单倍投入6元</p>
          <p>单选13场，双选0场，全包1场</p>
        </div>
      </div>

      <p class="pp">
        <span>2021-03-05 09:39</span>
        <span class="pp_span">
          <span><i class="el-icon-s-promotion"></i>转发</span>
          <span><i class="el-icon-chat-dot-square"></i>评论</span>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>关闭评论</el-dropdown-item>
                <el-dropdown-item>投诉</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </span>
      </p>
    </el-card>
  </div>
</template>
<script>
import { ref } from 'vue'
export default {
  setup() {
    let activeName = ref('all')
    let handleClick = () => {}
    return {
      activeName,
      handleClick
    }
  }
}
</script>
<style scoped lang="less">
.manner_box {
  h3 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  b {
    color: #000;
    font-size: 14px !important;
  }
  .el-card {
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 10px 0;
      .content_l {
        width: 12%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        span {
          padding: 6px;
        }
      }
      .content_l_h {
        background: #aaa;
        color: #fff;
      }
      .content_r {
        width: 83%;
        p {
          line-height: 26px;
        }
      }
    }
    .pp {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #8c8c8c;
      font-weight: 600;
      .pp_span {
        span {
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
